import { render, staticRenderFns } from "./NewAvailabilityPanel.vue?vue&type=template&id=27b797ee&scoped=true"
import script from "./NewAvailabilityPanel.vue?vue&type=script&lang=ts&setup=true"
export * from "./NewAvailabilityPanel.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./NewAvailabilityPanel.vue?vue&type=style&index=0&id=27b797ee&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27b797ee",
  null
  
)

export default component.exports